import {NgModule} from '@angular/core';
import {EnumOptionsPipe} from './enum-options.pipe';
import {ExpiryDatePipe} from './expiry-date.pipe';
import {FontawesomeMimePipe} from './fontawesome-mime.pipe';
import {InvalidControlsPipe} from './invalid-controls.pipe';
import {JoinPipe} from './join.pipe';
import {KeysPipe} from './keys.pipe';
import {LevelZonePipe} from './level-zone.pipe';
import {LinkifyPipe} from './linkify.pipe';
import {MessageTranslatePipe} from './message-translate.pipe';
import {SiteAddressPipe} from './site-address.pipe';
import {SpacesAfterCommasPipe} from './spaces-after-commas.pipe';
import {TimeAgoPipe} from './time-ago.pipe';
import {AbsolutePipe} from "@shared/pipes/abs.pipe";
import {TimeZonePipe} from "@shared/pipes/timezone.pipe";
import {AceKeyValuePipe} from './ace-keyvalue.pipe';
import {ConvertMsPipe} from './convert-ms.pipe';
import {MissingIdPipe} from './missing-id.pipe';
import {DurationPipe} from "@shared/pipes/duration.pipe";
import {AceDatePipe} from './ace-date.pipe';
import {MinMomentPipe} from './min-moment.pipe';

@NgModule({
    imports: [],
    declarations: [KeysPipe, SiteAddressPipe, SpacesAfterCommasPipe, InvalidControlsPipe, FontawesomeMimePipe, TimeAgoPipe,
                   LevelZonePipe, MessageTranslatePipe, LinkifyPipe, EnumOptionsPipe, ExpiryDatePipe, JoinPipe, AbsolutePipe, TimeZonePipe, AceKeyValuePipe,
                   ConvertMsPipe, MissingIdPipe, DurationPipe, AceDatePipe, MinMomentPipe],
    exports: [KeysPipe, SiteAddressPipe, SpacesAfterCommasPipe, InvalidControlsPipe, FontawesomeMimePipe, TimeAgoPipe,
              LevelZonePipe, MessageTranslatePipe, LinkifyPipe, EnumOptionsPipe, ExpiryDatePipe, JoinPipe, AbsolutePipe, TimeZonePipe, AceKeyValuePipe,
              ConvertMsPipe, MissingIdPipe, DurationPipe, AceDatePipe, MinMomentPipe]
})
export class SharedPipesModule {}
